import React, {FC, useState} from 'react';

import {useToggle} from '../../../../../libs/shared/helpers/src/react/hooks/hookHelpers';
import {Dropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {PopoverTransferProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {InviteDropdownCloseConfirmation} from '../../viewer/conversation/topbar/invite/inviteDropdownCloseConfirmation';
import {
  InviteDropdownInvite,
  InviteDropdownInvitePublicProps,
} from '../../viewer/conversation/topbar/invite/inviteDropdownInvite';

/*
 * Props.
 */

interface ShareDropdownProps extends PopoverTransferProps, InviteDropdownInvitePublicProps {}

/*
 * Component.
 */

export const ShareDropdown: FC<ShareDropdownProps> = (props) => {
  const [hasInviteComment, setHasInviteComment] = useState(false);
  const [isCloseConfirmationOpen, toggleIsCloseConfirmationOpen] = useToggle();

  const onHasCommentChange = (newHasInviteComment: boolean) => {
    setHasInviteComment(newHasInviteComment);
  };

  const onRequestClose = () => {
    // If there's a comment, we need to show a warning.
    if (hasInviteComment) {
      toggleIsCloseConfirmationOpen();
      return;
    }

    // Otherwise, close the dropdown.
    props.onRequestClose();
  };

  const onCloseConfirmationRequestClose = () => {
    toggleIsCloseConfirmationOpen();
  };

  const onCloseConfirmationOkClick = () => {
    props.onRequestClose();
  };

  return (
    <>
      <Dropdown {...props} width={320} onRequestClose={onRequestClose}>
        <InviteDropdownInvite {...props} onHasCommentChange={onHasCommentChange} />
      </Dropdown>
      {isCloseConfirmationOpen && (
        <InviteDropdownCloseConfirmation
          onRequestClose={onCloseConfirmationRequestClose}
          onOkClick={onCloseConfirmationOkClick}
        />
      )}
    </>
  );
};
